/**
 * Onglets du détail d'un run de job — les cinq du legacy (`run-details.component.html`), dans
 * son ordre : le journal d'abord, c'est ce qu'on vient voir, puis le rapport d'exécution que le run a
 * déclaré (lot L4, `GET …/report`, tout outil) ; puis, lot L07, la qualité (rapport de
 * la tâche « Contrôles qualité ») et le lignage (événements OpenLineage du run). L'onglet actif vit dans l'URL
 * (`?tab=`) : une capture ou un lien pointe sur un onglet précis.
 */
export const RUN_TABS = [
  'logs',
  'report',
  'events',
  'metrics',
  'files',
  'parameters',
  'quality',
  'lineage',
] as const;
export type RunTab = (typeof RUN_TABS)[number];

export const isRunTab = (value: unknown): value is RunTab =>
  typeof value === 'string' && (RUN_TABS as readonly string[]).includes(value);

/**
 * Séries lues par l'onglet Métriques : celles que graal-api sert depuis l'ADR 0053 (relevés de
 * `metrics.k8s.io`), `cpu` en cœurs et `memory` en Mio. Les séries disque et réseau du legacy
 * (`fs.*`, `net.*`, VictoriaMetrics) ne sont plus servies — le backend les refuse en 400.
 */
export const RUN_METRICS = ['cpu', 'memory'] as const;
export type RunMetric = (typeof RUN_METRICS)[number];

/** Clé i18n de chaque série : i18next lit le point comme un séparateur, `fs.reads` n'en est pas une. */
export const RUN_METRIC_LABEL_KEYS = {
  cpu: 'cpu',
  memory: 'memory',
} as const satisfies Record<RunMetric, string>;
